// extracted by mini-css-extract-plugin
module.exports = {"logOutHolder":"LogOutButton_logOutHolder__1X6Eh","logOutText":"LogOutButton_logOutText__5-B9B","logOutUserName":"LogOutButton_logOutUserName__2am2u"};